export const replaceWithInviteDestination = (url: string) => window.location.replace(url);
